import { c as _c } from "react/compiler-runtime";
import { SECTION_SKIP_COVER_FADE_IN_MS, SECTION_SKIP_COVER_FADE_OUT_MS } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/section-reset-veil/config';
import { cn } from '@/app/utils/cn';
export const SectionResetVeil = t0 => {
  const $ = _c(7);
  const {
    isVisible
  } = t0;
  const t1 = isVisible ? "opacity-100" : "opacity-0";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("pointer-events-none absolute inset-0 z-40 bg-black transition-opacity", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${isVisible ? SECTION_SKIP_COVER_FADE_IN_MS : SECTION_SKIP_COVER_FADE_OUT_MS}ms`;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      transitionDuration: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <div aria-hidden={true} className={t2} style={t4} />;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};